export default __webpack_public_path__ + "bml-characteristic3.15ad709.png";